import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingCart } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
interface CTAButtonProps {
  text?: string;
  subtext?: string;
  className?: string;
  onClick?: () => void;
}
const CHECKOUT_URL = 'https://growforgehq.com/products/the-commercial-cleaning-bid-blueprint';
export function CTAButton({
  text = 'ADD TO CART - $6.36',
  subtext = 'Instant Digital Access',
  className = '',
  onClick
}: CTAButtonProps) {
  const handleClick = () => {
    // Fire AddToCart. This sends a sendBeacon to Meta's /tr endpoint that is
    // guaranteed by the browser to be delivered even during navigation, so the
    // event reaches Meta even though we redirect in the same tab.
    trackAddToCart();
    // Custom handlers keep their existing (immediate) behavior.
    if (onClick) {
      onClick();
      return;
    }
    // Because the beacon survives navigation, we only need a tiny delay so the
    // request is definitely handed to the browser before we redirect.
    let navigated = false;
    const goToCheckout = () => {
      if (navigated) return;
      navigated = true;
      window.location.href = CHECKOUT_URL;
    };
    window.setTimeout(goToCheckout, 150);
  };
  return <div className={`flex flex-col items-center ${className}`} data-id="element-1">
      <motion.button whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.95
    }} onClick={handleClick} className="group relative flex w-full max-w-md flex-col items-center justify-center gap-1 overflow-hidden rounded-xl bg-gradient-to-b from-amber-400 to-amber-600 px-8 py-4 font-bold text-slate-900 shadow-[0_8px_30px_rgb(245,158,11,0.3)] transition-all hover:shadow-[0_8px_30px_rgb(245,158,11,0.5)]" data-id="element-2">
        <div className="absolute inset-0 flex h-full w-full justify-center [transform:skew(-12deg)_translateX(-100%)] group-hover:duration-1000 group-hover:[transform:skew(-12deg)_translateX(100%)]" data-id="element-3">
          <div className="relative h-full w-8 bg-white/20" data-id="element-4" />
        </div>
        <span className="relative flex items-center gap-2 text-2xl font-black uppercase tracking-wide md:text-3xl" data-id="element-5">
          <ShoppingCart className="h-6 w-6 md:h-8 md:w-8" data-id="element-6" />
          {text}
        </span>
      </motion.button>
      {subtext && <p className="mt-3 flex items-center gap-2 text-sm font-semibold text-slate-500 md:text-base" data-id="element-7">
          <span className="relative flex h-3 w-3" data-id="element-8">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-green-400 opacity-75" data-id="element-9"></span>
            <span className="relative inline-flex h-3 w-3 rounded-full bg-green-500" data-id="element-10"></span>
          </span>
          {subtext}
        </p>}
    </div>;
}